import { render, staticRenderFns } from "./DocsList.vue?vue&type=template&id=6900cf69"
import script from "./DocsList.vue?vue&type=script&lang=js"
export * from "./DocsList.vue?vue&type=script&lang=js"
import style0 from "./DocsList.vue?vue&type=style&index=0&id=6900cf69&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports